export default {
    consultant: "FullName",
    sap_no: "SAP",
    customer: "CustomerName",
    project: "ProjectTitle",
    level: "Levels",
    start: "StartDate",
    end: "EndDate",
    rate: "HourlyRate",
    engagement: "ProjectEngagement",
    days_left: "DaysLeft",
    time_left: "TimeLeft",
    oe: "OE",
    country: "Country",
    CustomerOE: "CustomerOE"
}
